exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "body{background-color:#000;font-size:100%;font-weight:700;margin:0}.progress{background:#4d5234;color:#4d5234;margin-bottom:5px}.progress::-webkit-progress-bar,.progress::-webkit-progress-value{background:#4d5234;color:#4d5234}.progress::-moz-progress-bar{background:#4d5234;color:#4d5234}.komande1,.komande2{width:140px}.prozorce{background-color:rgba(0,0,0,.8)}#dva-igraca{padding:5px 10px;font-size:16px}button.bg-avocado:hover{background-color:#4d5234}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./src/scena/style.scss
// module id = 32
// module chunks = 0